import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28acdea0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("全局搜索")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消搜索")
const _hoisted_10 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("搜索主题")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("搜索详情")
const _hoisted_15 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_16 = {
  class: "card-body p-0",
  style: {"overflow-x":"scroll"}
}
const _hoisted_17 = { class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "ID", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "操作", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "patrolStatus" }, "状态", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createTime" }, "发起时间", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "patrolName" }, "设备名称", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "patrolPerson" }, "巡检人员", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "personTime" }, "巡检时间", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "patrolMonitor" }, "监督人", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "monitorTime" }, "监督时间", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyName" }, "修改人", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyTime" }, "修改时间", -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["colspan"]
const _hoisted_31 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_32 = { class: "table-btn-group" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "badge badge-danger" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "badge badge-success" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { class: "normal-width text-left" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "content-modal" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "form-group col-lg-6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"vertical-align":"inherit"} }, "巡检时间", -1))
const _hoisted_45 = {
  class: "input-group date",
  id: "date1",
  "data-target-input": "nearest"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control datetimepicker-input",
  "data-target": "#reservationdate"
}, null, -1))
const _hoisted_47 = {
  class: "input-group-append",
  "data-target": "#reservationdate",
  "data-toggle": "datetimepicker"
}
const _hoisted_48 = { class: "input-group-text" }
const _hoisted_49 = { class: "form-group col-lg-6" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"vertical-align":"inherit"} }, "监督时间", -1))
const _hoisted_51 = {
  class: "input-group date",
  id: "date2",
  "data-target-input": "nearest"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control datetimepicker-input",
  "data-target": "#reservationdate"
}, null, -1))
const _hoisted_53 = {
  class: "input-group-append",
  "data-target": "#reservationdate",
  "data-toggle": "datetimepicker"
}
const _hoisted_54 = { class: "input-group-text" }

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_dropdown_search = _resolveComponent("app-dropdown-search")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_app_table_page = _resolveComponent("app-table-page")
  const _component_app_select_level = _resolveComponent("app-select-level")
  const _component_app_select_from_db = _resolveComponent("app-select-from-db")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_modal = _resolveComponent("app-modal")
  const _component_app_patrol_check = _resolveComponent("app-patrol-check")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-themes",
                onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.addModalOpen && _ctx.addModalOpen(...args)))
              }, "发起登记表")
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.Auth('/aftersale/inspection/patrol/list'))
                ? (_openBlock(), _createBlock(_component_app_dropdown_search, {
                    key: 0,
                    ref: "tableSearch",
                    modelValue: _ctx.tableRequestItem.searchKey,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.tableRequestItem.searchKey) = $event)),
                    searchFunction: _ctx.searchFunction,
                    disabledTableExport: !_ctx.Auth('/aftersale/inspection/patrol/export')
                  }, {
                    "dropdown-search-menu": _withCtx(() => [
                      _createElementVNode("li", {
                        class: "dropdown-item hyper-text-themes hand",
                        onClick: _cache[1] || (_cache[1] = $event => (_ctx.searchFunction('all')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-sharp",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_8
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.searchCancel()))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_9
                      ]),
                      (_ctx.tableRequestItem.lockItem)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tableRequestItem.lockItem, (item, key, i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                              (i===0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                                : _createCommentVNode("", true),
                              _createElementVNode("li", {
                                class: _normalizeClass([item.value?'hyper-text-themes':'', "dropdown-item hand"]),
                                onClick: item.openFn
                              }, [
                                _createVNode(_component_svg_icon, {
                                  name: item.value?'radio-button-on':'radio-button-off',
                                  class: "mt-0 mr-1"
                                }, null, 8, ["name"]),
                                _createTextVNode(" " + _toDisplayString(item.title), 1)
                              ], 10, _hoisted_11)
                            ], 64))
                          }), 128))
                        : _createCommentVNode("", true),
                      _hoisted_12,
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.searchFunction('t.work_subject')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_13
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[4] || (_cache[4] = $event => (_ctx.searchFunction('t.work_describe')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_14
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "searchFunction", "disabledTableExport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.tableRequestItem.dateTime,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.tableRequestItem.dateTime) = $event)),
                type: "datetimerange",
                shortcuts: _ctx.dateTimeShortcuts,
                size: "large",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                onChange: _cache[7] || (_cache[7] = $event => (_ctx.searchFunction('search')))
              }, null, 8, ["modelValue", "shortcuts"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _createElementVNode("th", {
                    field: "realName",
                    class: "table-search-lock hand active",
                    onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.userCodeLevelModalOpen && _ctx.userCodeLevelModalOpen(...args)))
                  }, "发起人"),
                  _createElementVNode("th", {
                    field: "patrolPlaceIdName",
                    class: "table-search-lock hand active",
                    onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.orgCodeLevelModalOpen && _ctx.orgCodeLevelModalOpen(...args)))
                  }, "巡检地点"),
                  _createElementVNode("th", {
                    field: "producerIdName",
                    class: "normal-width text-left table-search-lock hand active",
                    onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.producerIdLevelModalOpen && _ctx.producerIdLevelModalOpen(...args)))
                  }, "设备生产厂商"),
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24,
                  _hoisted_25,
                  _hoisted_26,
                  _hoisted_27,
                  _hoisted_28
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.tableItems.length<1)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                      _createElementVNode("td", {
                        colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                      }, [
                        _createVNode(_component_svg_icon, { name: "alert" }),
                        _hoisted_31
                      ], 8, _hoisted_30)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.patrolId,
                    class: _normalizeClass({'text-red': parseInt(item.patrolStatus)===2})
                  }, [
                    _createElementVNode("td", null, _toDisplayString(((_ctx.tablePageItems.current-1) * _ctx.tablePageItems.size) + i + 1), 1),
                    _createElementVNode("td", _hoisted_32, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-themes",
                        onClick: $event => (_ctx.openPatrolCheckModal(item))
                      }, [
                        _createVNode(_component_svg_icon, { name: "settings-outline" })
                      ], 8, _hoisted_33)
                    ]),
                    (item.patrolStatus===27)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                          _createElementVNode("span", _hoisted_35, _toDisplayString(item.patrolStatusName), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_36, [
                          _createElementVNode("span", _hoisted_37, _toDisplayString(item.patrolStatusName), 1)
                        ])),
                    _createElementVNode("td", {
                      class: "p-0",
                      innerHTML: item.createTime.replace(' ', '<\/br>')
                    }, null, 8, _hoisted_38),
                    _createElementVNode("td", {
                      class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.userCode.value? 'active' : ''])
                    }, _toDisplayString(item.realName), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.orgCode.value? 'active' : ''])
                    }, _toDisplayString(item.patrolPlaceIdName), 3),
                    _createElementVNode("td", _hoisted_39, _toDisplayString(item.producerIdName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.patrolName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.patrolPerson), 1),
                    _createElementVNode("td", null, _toDisplayString(item.personTime), 1),
                    _createElementVNode("td", null, _toDisplayString(item.patrolMonitor), 1),
                    _createElementVNode("td", null, _toDisplayString(item.monitorTime), 1),
                    _createElementVNode("td", null, _toDisplayString(item.modifyName), 1),
                    _createElementVNode("td", {
                      class: "p-0",
                      innerHTML: item.modifyTime.replace(' ', '<\/br>')
                    }, null, 8, _hoisted_40)
                  ], 2))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_component_app_table_page, {
            class: "card-footer",
            pageItems: _ctx.tablePageItems,
            pageFunction: _ctx.getList
          }, null, 8, ["pageItems", "pageFunction"])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_41, [
      _createVNode(_component_app_select_level, {
        ref: "userCodeLevel",
        levelType: "onLest",
        levelApi: _ctx.getUserApi,
        selectItem: _ctx.tableRequestItem.lockItem.userCode,
        maxParentId: _ctx.authUser.orgCode,
        selectFunction: _ctx.userCodeLevelFunction,
        searchFieldList: _ctx.userCodeLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "maxParentId", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "orgCodeLevel",
        levelType: "select",
        levelApi: _ctx.getOrgApi,
        selectItem: _ctx.tableRequestItem.lockItem.orgCode,
        maxParentId: _ctx.authUser.orgCode,
        selectFunction: _ctx.orgCodeLevelFunction,
        searchFieldList: _ctx.orgCodeLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "maxParentId", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "producerIdLevel",
        levelType: "select",
        levelApi: _ctx.getProducerApi,
        selectItem: _ctx.tableRequestItem.lockItem.businessId,
        selectFunction: _ctx.producerIdLevelFunction,
        searchFieldList: _ctx.producerIdLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_modal, {
        ref: "editModal",
        title: "发起巡检登记表",
        submitButtonName: "提交",
        size: "lg",
        submitFunction: _ctx.editModalSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-12",
              label: "设备生产厂商",
              modelValue: _ctx.editModalItem.producerId,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.editModalItem.producerId) = $event)),
              searchApi: _ctx.producerIdSelectApi
            }, null, 8, ["modelValue", "searchApi"]),
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-12",
              label: "巡检地点",
              modelValue: _ctx.editModalItem.patrolPlaceId,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.editModalItem.patrolPlaceId) = $event)),
              searchApi: _ctx.orgCodeSelectApi
            }, null, 8, ["modelValue", "searchApi"]),
            _createVNode(_component_app_input, {
              class: "col-lg-12",
              label: "设备名称",
              modelValue: _ctx.editModalItem.patrolName,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.editModalItem.patrolName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "巡检人员",
              modelValue: _ctx.editModalItem.patrolPerson,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.editModalItem.patrolPerson) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_svg_icon, { name: "calendar-outline" })
                  ])
                ])
              ])
            ]),
            _createVNode(_component_app_input, {
              class: "col-lg-6",
              label: "监督人员",
              modelValue: _ctx.editModalItem.patrolMonitor,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.editModalItem.patrolMonitor) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_svg_icon, { name: "calendar-outline" })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["submitFunction"]),
      _createVNode(_component_app_patrol_check, {
        ref: "patrolCheckModal",
        valueList: _ctx.editModalItem
      }, null, 8, ["valueList"])
    ])
  ]))
}